<div ng-if="editor.isDesigning()" ng-show="isDragged" class="shadow"></div>
<c-form-element-actions ng-if="editor.isDesigning()" editor="editor" element="field"></c-form-element-actions>
<label ng-class="{selectable:editor.isDesigning()}" ng-mousedown="editor.dragBegin(field, $event)" title="{{(editor.isDesigning() ? 'move':'')|translate}}" for="noteField-{{field.Id}}" ng-bind-html="labelText"></label>
<span class="field-description" ng-bind-html="descriptionText"></span>
<table ng-if="!tool">
    <thead>
    <th class="timestamp">{{"note.time"|translate}}</th>
    <th class="name">{{"note.by"|translate}}</th>
    <th class="text">{{"note.text"|translate}}</th>
    <!--<th class="stage">{{"note.stage"|translate}}</th>--> <!--removed the column stage to fix narrow text from text field-->
    <th></th>
    <th></th>
    </thead>
    <tbody>
        <tr ng-repeat="item in fieldValue.Notes|orderBy:'-Timestamp' track by $index">
            <td>{{item.Timestamp|cDate:"":"medium"}}</td>
            <td>{{item.User.DisplayName}}</td>
            <td>{{item.Text}}</td>
            <!--<td>{{item.StageName|localize}}</td>--> <!--removed the column stage to fix narrow text from text field-->
            <td><a style="white-space: nowrap" ng-if="iseditable(item)" ng-click="editNote(item)">{{"edit"|translate:language}}</a></td>
            <td><a style="white-space: nowrap" ng-if="iseditable(item)" ng-click="removeNote(item)">{{"delete"|translate:language}}</a></td>
        </tr>
    </tbody>
</table>
<div class="add-note" ng-if="editable">
    <button type="button" ng-click="addNote()">{{noteMessage}}</button>
</div>
